const PopoverContentTheme = {
  popoverContent:
    "z-[1070] p-1 block max-w-[267px] rounded break-words text-sm not-italic font-normal text-left no-underline underline-offset-auto normal-case leading-6 tracking-normal break-normal whitespace-normal dark:text-white data-[popper-reference-hidden='true']:hidden",
  fade: "transition-opacity ease-linear motion-reduce:transition-none",
};

export default PopoverContentTheme;
